module.exports = __webpack_public_path__ + "img/cup_n2.136e99ef.png";